import genders, { defaultGender } from "../../constants/genders";
export var getPronounFromGender = function (gender) {
    var selectedGender = genders.find(function (genderItem) { return genderItem.initial === gender; });
    if (!selectedGender) {
        return defaultGender.pronoun;
    }
    return selectedGender.pronoun;
};
